import { Styles } from '../../theme/materialTheme';

export const emailInput: Styles = {
  mt: 1.5,
};

export const passwordInput: Styles = {
  mt: 3,
};
